export const CollapsedFieldsInJsonView = [
	'fromAddress',
	'toAddress',
	'altReturnAddress',
	'rates',
	'forms',
	'tracking',
	'specialServiceParam',
	'postageLabel',
	'billTo',
];



// WEBPACK FOOTER //
// ./src/constants/shipment.constants.ts